import type { ChangelogEntry } from "../types";

/** Utstyrsregisteret fra Sølvrevs verktøy, med forsikringsoversikt. */
export const UTSTYRSREGISTER_2026_10: ChangelogEntry = {
  id: "2026-10-24-utstyrsregister",
  date: "2026-10-24",
  title: "Utstyrsregisteret er på plass i Revehiet",
  summary:
    "Alt utstyret fra Sølvrevs verktøy, 258 rader i Oslo og Bergen, ligger nå under Utstyr, med utstyrskort, registrering og en forsikringsoversikt. Booking kommer i neste steg.",
  sections: [
    {
      heading: "Utstyr",
      minRole: "user",
      items: [
        {
          title: "Utstyrslista",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Én tabell med kategorier som knapper, Oslo, Bergen eller Begge (starter på din avdeling), søk og status. Utstyr finnes også i søket øverst.",
        },
        {
          title: "Utstyrskortet",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Fakta, deler og tilbehør, egne bilder og historikk over hvem som har endret hva. Importert utstyr viser hva som sto under «I bruk?» i verktøyet.",
        },
      ],
    },
    {
      heading: "For administratorer og utstyrsansvarlige",
      minRole: "admin",
      items: [
        {
          title: "Registrer og rediger utstyr",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Innkjøpspris og forsikringsverdi vises bare for administratorer og utstyrsansvarlige. Utstyrsansvarlig og avdeling settes under Innstillinger, Brukere.",
        },
        {
          title: "Forsikringsoversikt",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Viser det som utløper innen 90 dager og det som ikke er forsikret, med Forny (også for flere valgte), Ikke forny, Forsikre og Selg eller utranger. Erstatter gjennomgangskøen i verktøyet.",
        },
      ],
    },
  ],
};
